var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center w-100 mb-2",
          class: [
            "d-flex align-items-center w-100",
            { "sticky-header": _vm.showHeader }
          ]
        },
        [
          !_vm.showDetails
            ? _c("h5", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-secondary mr-1 ml-auto",
              attrs: { disabled: _vm.isBusy },
              on: {
                click: function($event) {
                  return _vm.openModalCopying()
                }
              }
            },
            [
              _c("v-icon", { attrs: { name: "buttons/copy", size: 13 } }),
              _vm._v("\n      Копировать\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle.sidebar-fields-location-vacancies",
                  modifiers: { "sidebar-fields-location-vacancies": true }
                }
              ],
              staticClass: "custom-btn-secondary mr-1",
              attrs: { id: "table-settings", disabled: _vm.isBusy }
            },
            [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tooltip",
            {
              attrs: {
                target: "table-settings",
                triggers: "hover",
                "custom-class": "custom-tooltip",
                noninteractive: ""
              }
            },
            [_vm._v("\n      Строки\n    ")]
          ),
          _vm._v(" "),
          !_vm.showDetails
            ? _c(
                "b-button",
                {
                  staticClass: "custom-btn-primary",
                  attrs: { disabled: _vm.isBusy || _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onAdd()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                  _vm._v("\n      Добавить\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showHeader
            ? _c(
                "b-button",
                {
                  staticClass: "text-dark ml-3 p-0",
                  attrs: { variant: "link" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("v-icon", { attrs: { name: "buttons/cross", size: 15 } })],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.items.length > 0
        ? _c(
            "div",
            { staticClass: "vacancies-layout" },
            _vm._l(_vm.cardGroups, function(group) {
              return _c(
                "div",
                { key: group.id, staticClass: "custom-card card-body mb-4" },
                [
                  _c("h6", { staticClass: "text-secondary text-small" }, [
                    _vm._v(_vm._s(group.title))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "custom-card-grid-container",
                      style: _vm.gridStyle
                    },
                    _vm._l(group.fields, function(field) {
                      return _c(
                        "div",
                        {
                          key: field.key,
                          staticStyle: { display: "contents" }
                        },
                        [
                          _c("div", { staticClass: "custom-card-label-cell" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center w-100"
                              },
                              [
                                field.required
                                  ? _c(
                                      "span",
                                      { staticClass: "text-danger mr-2" },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-normal mr-auto" },
                                  [_vm._v(_vm._s(field.label))]
                                ),
                                _vm._v(" "),
                                field.isJoint && _vm.items.length > 1
                                  ? _c("b-form-checkbox", {
                                      staticClass: "warning-checkbox ml-2 mb-0",
                                      attrs: { value: field.key, switch: "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onToggleJoint(field.key)
                                        }
                                      },
                                      model: {
                                        value: _vm.jointFields,
                                        callback: function($$v) {
                                          _vm.jointFields = $$v
                                        },
                                        expression: "jointFields"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.items, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: "data-" + field.key + "-" + index,
                                staticClass: "custom-card-data-cell"
                              },
                              [
                                _vm.isFieldJoint(field.key)
                                  ? [
                                      index === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "w-100",
                                              style: {
                                                gridColumn:
                                                  "span var(--data-columns, 1)"
                                              }
                                            },
                                            [
                                              _vm.isFieldJoint(field.key)
                                                ? _c(
                                                    "div",
                                                    { staticClass: "px-1" },
                                                    [
                                                      field.key ===
                                                      "citizenships"
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "citizenships-multi-select",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .citizenships,
                                                                    "catalog-items":
                                                                      _vm.citizenshipsCatalog,
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "citizenships",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.key ===
                                                          "employment"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "base-multi-select",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .employment_types,
                                                                    options:
                                                                      _vm.employmentTypesOptions,
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "employment_types",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  staticClass:
                                                                    "text-small",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .employment,
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    rows: "2",
                                                                    placeholder:
                                                                      field.placeholder
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "employment",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.key ===
                                                          "employment_categories"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "employment-categories-multi-select",
                                                                {
                                                                  staticClass:
                                                                    "w-100",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .employment_categories,
                                                                    "catalog-items":
                                                                      _vm.employmentCategoriesCatalog,
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "employment_categories",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.key ===
                                                          "certificates"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "driver-license-categories-multi-select",
                                                                {
                                                                  staticClass:
                                                                    "w-25 mr-1",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .driver_license_categories,
                                                                    "catalog-items":
                                                                      _vm.driverLicenseCategoriesCatalog,
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "driver_license_categories",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  staticClass:
                                                                    "w-75 text-small",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .certificates,
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    rows: "2",
                                                                    placeholder:
                                                                      field.placeholder
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "certificates",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.key ===
                                                          "shift_hours"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center px-1"
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    type:
                                                                      "time",
                                                                    value: _vm.getShiftTime(
                                                                      _vm
                                                                        .items[0]
                                                                        .shift_hours,
                                                                      0
                                                                    ),
                                                                    disabled:
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateShiftTimeJoint(
                                                                        0,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    type:
                                                                      "time",
                                                                    value: _vm.getShiftTime(
                                                                      _vm
                                                                        .items[0]
                                                                        .shift_hours,
                                                                      1
                                                                    ),
                                                                    disabled:
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateShiftTimeJoint(
                                                                        1,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.key ===
                                                          "schedule"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  staticClass:
                                                                    "mr-1 text-small",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .schedule,
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    rows: "1",
                                                                    "max-rows":
                                                                      "4",
                                                                    placeholder:
                                                                      "График"
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "schedule",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "base-multi-select",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .schedule_time_of_day,
                                                                    options:
                                                                      _vm.shiftOptions,
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "schedule_time_of_day",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  staticClass:
                                                                    "text-small",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .night_coefficient,
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    rows: "2",
                                                                    "max-rows":
                                                                      "6",
                                                                    placeholder:
                                                                      "Ночной коэф."
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "night_coefficient",
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.type === "input"
                                                        ? _c(
                                                            "b-form-textarea",
                                                            {
                                                              staticClass:
                                                                "text-small",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isDisabled,
                                                                rows: "2",
                                                                "max-rows": "6",
                                                                value:
                                                                  _vm.items[0][
                                                                    field.key
                                                                  ],
                                                                placeholder:
                                                                  field.placeholder ||
                                                                  "Значение для всех вакансий"
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateAllItems(
                                                                    field.key,
                                                                    $event
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : field.type ===
                                                          "number"
                                                        ? _c("b-form-input", {
                                                            staticClass:
                                                              "text-small",
                                                            attrs: {
                                                              disabled:
                                                                _vm.isDisabled,
                                                              type: "number",
                                                              min: 0,
                                                              value:
                                                                _vm.items[0][
                                                                  field.key
                                                                ],
                                                              placeholder:
                                                                field.placeholder ||
                                                                "Введите число"
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateAllItems(
                                                                  field.key,
                                                                  $event
                                                                )
                                                              },
                                                              keydown:
                                                                _vm.onlyNumbers
                                                            }
                                                          })
                                                        : field.type === "range"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center w-100 px-5"
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "text-small mr-5",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    type:
                                                                      "number",
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .age_from,
                                                                    placeholder:
                                                                      "От"
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "age_from",
                                                                        $event
                                                                      )
                                                                    },
                                                                    keydown:
                                                                      _vm.onlyNumbers
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "text-small",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    type:
                                                                      "number",
                                                                    value:
                                                                      _vm
                                                                        .items[0]
                                                                        .age_to,
                                                                    placeholder:
                                                                      "До"
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        "age_to",
                                                                        $event
                                                                      )
                                                                    },
                                                                    keydown:
                                                                      _vm.onlyNumbers
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.type ===
                                                          "checkbox-input"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center w-100 px-3"
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  staticClass:
                                                                    "mr-2 mb-0",
                                                                  attrs: {
                                                                    checked:
                                                                      _vm
                                                                        .items[0][
                                                                        field
                                                                          .key
                                                                      ],
                                                                    disabled:
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        field.key,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  staticClass:
                                                                    "text-small",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0][
                                                                        field
                                                                          .commentKey
                                                                      ],
                                                                    disabled:
                                                                      _vm.isDisabled,
                                                                    rows: "2",
                                                                    "max-rows":
                                                                      "6",
                                                                    placeholder:
                                                                      field.placeholder ||
                                                                      "Добавьте комментарий"
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        field.commentKey,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : field.type ===
                                                          "multiselect"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-center w-100"
                                                            },
                                                            [
                                                              _c(
                                                                "base-multi-select",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .items[0][
                                                                        field
                                                                          .key
                                                                      ],
                                                                    options: _vm.getOptions(
                                                                      field.optionsKey
                                                                    ),
                                                                    "is-disabled":
                                                                      _vm.isDisabled
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.updateAllItems(
                                                                        field.key,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : [
                                      field.key === "vacancy"
                                        ? _c(
                                            "div",
                                            { staticClass: "w-100 d-flex" },
                                            [
                                              _c("vacancy-select", {
                                                ref: "vacancy_select",
                                                refInFor: true,
                                                staticClass: "w-100",
                                                attrs: {
                                                  value:
                                                    _vm.items[index].vacancy_id,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                on: {
                                                  onSelect: function($event) {
                                                    return _vm.onSelectVacancy(
                                                      $event,
                                                      index
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              !_vm.showDetails
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "custom-btn-danger ml-1",
                                                      attrs: {
                                                        disabled: _vm.isDisabled
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onRemove(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", {
                                                        attrs: {
                                                          name: "buttons/trash",
                                                          size: 14
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : field.key === "citizenships"
                                        ? _c(
                                            "div",
                                            { staticClass: "w-100" },
                                            [
                                              _c("citizenships-multi-select", {
                                                attrs: {
                                                  "catalog-items":
                                                    _vm.citizenshipsCatalog,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index]
                                                      .citizenships,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "citizenships",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].citizenships"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.key === "employment_categories"
                                        ? _c(
                                            "div",
                                            { staticClass: "w-100" },
                                            [
                                              _c(
                                                "employment-categories-multi-select",
                                                {
                                                  attrs: {
                                                    "catalog-items":
                                                      _vm.employmentCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.items[index]
                                                        .employment_categories,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.items[index],
                                                        "employment_categories",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "items[index].employment_categories"
                                                  }
                                                }
                                              )
                                            ],
                                            1
                                          )
                                        : field.key === "employment"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center w-100"
                                            },
                                            [
                                              _c("base-multi-select", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  options:
                                                    _vm.employmentTypesOptions,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index]
                                                      .employment_types,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "employment_types",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].employment_types"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder: field.placeholder
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index].employment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "employment",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].employment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.key === "certificates"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center flex-wrap w-100"
                                            },
                                            [
                                              _c(
                                                "driver-license-categories-multi-select",
                                                {
                                                  staticClass: "mr-1",
                                                  staticStyle: {
                                                    flex: "1 1 40%"
                                                  },
                                                  attrs: {
                                                    "catalog-items":
                                                      _vm.driverLicenseCategoriesCatalog,
                                                    "is-disabled":
                                                      _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.items[index]
                                                        .driver_license_categories,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.items[index],
                                                        "driver_license_categories",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "items[index].driver_license_categories"
                                                  }
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                staticStyle: {
                                                  flex: "1 1 50%"
                                                },
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  placeholder: field.placeholder
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index]
                                                      .certificates,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "certificates",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].certificates"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.key === "shift_hours"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center w-100"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "mr-1 text-center",
                                                staticStyle: {
                                                  "max-width": "120px"
                                                },
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[index]
                                                      .shift_hours,
                                                    0
                                                  ),
                                                  disabled: _vm.isDisabled
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeSeparated(
                                                      index,
                                                      0,
                                                      $event
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "text-center",
                                                staticStyle: {
                                                  "max-width": "120px"
                                                },
                                                attrs: {
                                                  type: "time",
                                                  value: _vm.getShiftTime(
                                                    _vm.items[index]
                                                      .shift_hours,
                                                    1
                                                  ),
                                                  disabled: _vm.isDisabled
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.updateShiftTimeSeparated(
                                                      index,
                                                      1,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.key === "schedule"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center w-100"
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                staticClass: "mr-1 text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder: "Укажите график"
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index].schedule,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "schedule",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].schedule"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("base-multi-select", {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  options: _vm.shiftOptions,
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index]
                                                      .schedule_time_of_day,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "schedule_time_of_day",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].schedule_time_of_day"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder: "Ночной коэф."
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index]
                                                      .night_coefficient,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "night_coefficient",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].night_coefficient"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.type === "input"
                                        ? _c("b-form-textarea", {
                                            staticClass: "text-small",
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              rows: "2",
                                              "max-rows": "6",
                                              placeholder: field.placeholder
                                            },
                                            model: {
                                              value:
                                                _vm.items[index][field.key],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.items[index],
                                                  field.key,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "items[index][field.key]"
                                            }
                                          })
                                        : field.type === "number"
                                        ? _c("b-form-input", {
                                            staticClass: "text-small",
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              min: 0,
                                              type: "number",
                                              placeholder: field.placeholder
                                            },
                                            on: { keydown: _vm.onlyNumbers },
                                            model: {
                                              value:
                                                _vm.items[index][field.key],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.items[index],
                                                  field.key,
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "items[index][field.key]"
                                            }
                                          })
                                        : field.type === "range"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center w-100 px-4"
                                            },
                                            [
                                              _c("b-form-input", {
                                                staticClass: "mr-4",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "От"
                                                },
                                                on: {
                                                  keydown: _vm.onlyNumbers
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index].age_from,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "age_from",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].age_from"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  type: "number",
                                                  min: "0",
                                                  placeholder: "До"
                                                },
                                                on: {
                                                  keydown: _vm.onlyNumbers
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index].age_to,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      "age_to",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "items[index].age_to"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.type === "checkbox-input"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center w-100"
                                            },
                                            [
                                              _c("b-form-checkbox", {
                                                staticClass: "mr-2 mb-0",
                                                attrs: {
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index][field.key],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      field.key,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index][field.key]"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticClass: "text-small",
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                  rows: "2",
                                                  "max-rows": "6",
                                                  placeholder:
                                                    field.placeholder ||
                                                    "Комментарий"
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index][
                                                      field.commentKey
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      field.commentKey,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index][field.commentKey]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : field.type === "multiselect"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-center w-100"
                                            },
                                            [
                                              _c("base-multi-select", {
                                                attrs: {
                                                  options: _vm.getOptions(
                                                    field.optionsKey
                                                  ),
                                                  "is-disabled": _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.items[index][field.key],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.items[index],
                                                      field.key,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "items[index][field.key]"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        : _vm.isBusy
        ? _c(
            "div",
            { staticClass: "text-center text-success my-2" },
            [
              _c("b-spinner", { staticClass: "align-middle" }),
              _vm._v(" "),
              _c("strong", [_vm._v("Загрузка")])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "empty-state-container" },
            [
              _c("v-icon", { attrs: { name: "navbar/empty_table", size: 90 } }),
              _vm._v(" "),
              _c("h5", [_vm._v("Нет созданных вакансий.")]),
              _vm._v(" "),
              _c("p", [_vm._v("Создайте новую вакансию объекта прямо сейчас")]),
              _vm._v(" "),
              !_vm.showDetails
                ? _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-primary",
                      attrs: { disabled: _vm.isBusy || _vm.isDisabled },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.onAdd()
                        }
                      }
                    },
                    [
                      _c("v-icon", {
                        attrs: { name: "buttons/plus", size: 12 }
                      }),
                      _vm._v("\n      Новая вакансия\n    ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      !_vm.showDetails
        ? _c(
            "div",
            { staticClass: "page-pagination mt-2" },
            [
              _c("pagination-footer", {
                attrs: { "total-rows": _vm.items.length, "per-page": 50 },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer-pagination",
                      fn: function() {
                        return [_c("div", { staticClass: "d-none" })]
                      },
                      proxy: true
                    },
                    {
                      key: "footer-per-page",
                      fn: function() {
                        return [_c("div", { staticClass: "d-none" })]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2787570364
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_vacancy_copying",
          attrs: {
            id: "modal-vacancy-copying",
            title: "Текст вакансий объекта",
            size: "xl",
            "modal-class": "custom-modal",
            lazy: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.closeModalCopying()
                        }
                      }
                    },
                    [_vm._v("\n        Назад\n      ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showModalCopying,
            callback: function($$v) {
              _vm.showModalCopying = $$v
            },
            expression: "showModalCopying"
          }
        },
        [
          _vm.items.length > 0
            ? _c(
                "b-form",
                [
                  _c(
                    "b-tabs",
                    {
                      staticClass: "custom-tabs ml-2",
                      attrs: { card: "", vertical: "" }
                    },
                    _vm._l(_vm.items, function(item, index) {
                      return _c(
                        "b-tab",
                        {
                          key: index,
                          attrs: { title: _vm.vacancyModalTabTitles[index] }
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "ml-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "custom-btn-primary",
                                      on: {
                                        click: function($event) {
                                          return _vm.copyToClipboard(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/copy",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(
                                        "\n                Скопировать текст\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            staticClass: "p-3 bg-light copy-textarea",
                            attrs: {
                              id: "vacancy-text-" + index,
                              "no-resize": "",
                              readonly: "",
                              rows: "45",
                              value: _vm.generateVacancyText(item)
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "text-center text-muted py-4" }, [
                _vm._v("\n      Нет добавленных вакансий.\n    ")
              ])
        ],
        1
      ),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "locationVacancies_columns",
          "sidebar-fields": "sidebar-fields-location-vacancies",
          "fields-model": _vm.columns,
          fieldKey: "vacancy",
          "configure-required": true
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.columns = $event
          },
          "update:fields-model": function($event) {
            _vm.columns = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80c63bda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80c63bda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationVacancies.vue
// module id = null
// module chunks = 